<template>
  <div class="dropdown" :class="{'dropdown--open':isOpen}">
    <div class="dropdown__btn u-bg-grey u-flex u-around u-middle u-absolute u-cursor-pointer" @click="onToggle">
      <div class="dropdown__btn--img u-bg-black u-marg-l-xs u-overflow-hidden u-box-1by1">
        <img :src="picture" alt="Avatar picture" class="u-wrapper-panel u-fit-cover">
      </div>
      <div class="dropdown__btn--icon u-marg-r-sm u-relative">
      </div>
    </div>

    <transition name="t-fader">
      <div v-if="isOpen" class="dropdown__content u-bg-grey u-pad-md u-white u-absolute u-marg-l-md u-marg-l-0--xs u-w8of8--xs u-pad-sm--sm">
        <div class="dropdown__content__info u-flex u-relative">
          <div class="dropdown__content__info--img u-bg-black u-box-1by1 u-relative">
            <div class="dropdown__content__info--img__panel u-wrapper-panel u-overflow-hidden">
              <img :src="picture" class="u-wrapper-panel u-fit-cover" alt="Avatar picture">
            </div>
            <!-- <div class="dropdown__content__info--switch u-bg-grey u-cursor-pointer u-flex u-center u-middle">
              <img src="/images/switch.png" alt="Switch icon">
            </div> -->
          </div>
          <div class="u-marg-l-md u-marg-l-sm--sm">
            <label class="dropdown__content__info--switch__label t-text--xsmall">{{$t('dropdown.name')}}</label>
            <p class="u-marg-b-xs" >
              {{firstName}} {{lastName}}
            </p>
            <label class="dropdown__content__info--switch__label t-text--xsmall">{{$t('dropdown.company')}}</label>
            <p class="u-marg-b-xs">
              {{company}}
            </p>
            <label class="dropdown__content__info--switch__label t-text--xsmall">{{$t('dropdown.role')}}</label>
            <p class="">
              {{role}}
            </p> 
          </div>
          <div class="dropdown__content__info--edit u-absolute u-cursor-pointer" @click="onEdit">
            <div class="u-flex u-center">
              <div class="u-bg-white u-overflow-hidden">
                <img src="/images/pencil.png" alt="Pencil icon" class="u-full-height u-full-width u-fit-contain">
              </div>
            </div>
            <p class="u-center t-text--xsmall u-marg-t-xs">{{ $t('dropdown.edit') }}</p>
          </div>
          <div class="dropdown__content__info--logout u-absolute u-cursor-pointer" @click="onLogout">
            <div class="u-flex u-center">
              <div class="u-bg-white u-overflow-hidden">
                <img src="/images/logout.png" alt="Logout icon" class="u-full-height u-full-width u-fit-contain">
              </div>
            </div>
            <p class="u-center t-text--xsmall u-marg-t-xs">{{ $t('dropdown.logout') }}</p>
          </div>
        </div>
        <div class="dropdown__content__fav u-marg-t-lg">
          <p class="t-h3 u-marg-b-md">{{$t('dropdown.favorites')}}</p>
          <div class="dropdown__content__fav--list u-overflow-y-scroll u-no-scroll-bar">

            <template v-if="favorites.length">
              <!-- loop sur app-card -->
              <app-card
                v-for="(card, index) in favorites"
                v-if="$store.getters['data/getEntityFav'](card.id)"
                class="u-marg-b-md"
                bg="black"
                :content="card"
                :key="'card-'+index"
                :url="$store.getters['data/getEntityFav'](card.id).url"
              />
            </template>
            <template v-else>
              <div class="t-text t-text--big u-white u-center u-marg-t-lg">
                {{ $t('district.noContent') }}
              </div>
            </template>
          </div>
        </div>
         <app-button :hasGradientBorder="true" class="u-marg-l-4of8" @click="isOpen = !isOpen">{{$t('dropdown.close')}}</app-button>
      </div>
    </transition>

  </div>
</template>

<script>
import { auth } from '@/utils/Auth'

import AppCard from '@/components/common/AppCard'

export default {
  components:
  {
    AppCard
  },

  computed: {
    firstName () {
      return this.$store.getters['user/user'].firstName
    },
    lastName () {
      return this.$store.getters['user/user'].lastName
    },
    company () {
      return this.$store.getters['user/user'].company
    },
    role () {
      return this.$store.getters['user/user'].role
    },
    picture () {
      return this.$store.getters['user/user'].avatarPic
    },
    email () {
      return this.$store.getters['user/user'].email
    },
    favorites () {
      return this.$store.getters['data/favorites']
    }
  },
  data () {
    return {
      isOpen: false
    }
  },

  watch: {
    $route () {
      this.isOpen = false
    }
  },

  methods: {
    onLogout () {
      this.$ga.send('Menu', 'Click', 'Logout')
      auth.logout()
    },
    onToggle () {
      this.$ga.send('Menu', 'Click', 'Menu button')
      this.isOpen = !this.isOpen
    },
    onEdit () {
      this.$ga.send('Menu', 'Click', 'Edit profile')
      this.$router.push(this.$local(this.$device.isTablet ? 'account' : 'avatar'))
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/mixins/viewport-sizer'
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.dropdown
  &__btn
    height 45px
    width 90px
    border-radius 100px
    top: $spacings.md
    left: $spacings.md
    &--img
      border-radius 50px
      height 28px
      width 28px
    &--icon
      height 18px
      width 22px
      border-bottom: 2px solid $colors.white
      border-top: 2px solid $colors.white
      &:before
        content ''
        height 2px
        width 22px
        background $colors.white
        position absolute
        top calc(50% - 1px)
        left 0

  &__content
    top 100px
    width 500px
    border-radius 15px
    height calc(100vh - 130px)
    z-index 2
    @media ( max-width: $mq-breakpoints.mobile )
      height calc(100vh - 80px)
    &__info
      &--img
        height 130px
        width 130px
        border-radius 50%
        &__panel
          border-radius 50%
        @media ( max-width: $mq-breakpoints.mobile )
          height 80px
          width 80px
        
      &--switch
        position absolute !important
        height 40px
        width 40px
        border-radius 50%
        bottom -20px
        left 50%
        margin-left -20px
          
        &__label
          margin 0
        img 
          width 70px

      &--edit
        right 0px
        top 0px

        @media ( min-width: $mq-breakpoints.wide )
          width 100px


        div > div
          height 40px
          width 40px
          border-radius 50%
          padding 10px

      &--logout
        right 0px
        top calc( 55px + 1em )

        @media ( min-width: $mq-breakpoints.wide )
          width 100px

        div > div
          height 40px
          width 40px
          border-radius 50%
          padding 10px
        
    &__fav
      &--list
        height calc(100vh - 480px)
        &__elem
          border-radius 10px
          .elem-type
            background: $gradients.green
            border-radius 5px
    .t-button 
      transform translateX(-50%)
</style>